import React from 'react';
import './AllWork.css'
import AllProjects from '../../Data/AllProjects';
import Navigation from '../Shared/Navigation/Navigation';
import Footer from '../Shared/Footer/Footer';
import SingleWork from './SingleWork/SingleWork';

const AllWork = () => {
    const projects = AllProjects;
    console.log(projects);
    return (
        <div>
            <Navigation />
            <main id="work" className='container pb-4 pt-4'>
                <h2 className='pt-3'  data-aos='fade-right'>Some of my best projects</h2>
                <div className="project-page">
                    {
                        projects.map(project => <SingleWork key={project.id} project ={project}></SingleWork> )
                    }
                </div>
                <div className='pt-3 d-flex justify-content-center' data-aos="fade-right" data-aos-duration="500">
                    <a href='https://github.com/ShahinurAlamBhuiyan?tab=repositories' className='btn btn-secondary w-25' target='_blank'><i className="fa fa-github"></i>&nbsp; ALL PROJECTS</a>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default AllWork;